import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { State } from '@app/store/state/state';
import * as actions from '@shared/travel-assistance/store/actions/assistance.actions';
import { UiAssistanceState } from '@shared/travel-assistance/store/state/assistance.state';
import { getUIAssistanceState } from '@shared/travel-assistance/store/selectors/ui.selector';
import { assistanceRootSelector } from '@shared/travel-assistance/store/selectors/assistance-root.selector';
import {
  AssistanceSearchResponse, AssistanceSearchPayload, AssistanceBookPayload,
  AssistanceCancellationPayload, AssistanceConvertPdfPayload
} from '@shared/travel-assistance/entities/booking-assistance';
import { TravelBookingType } from '@app/modules/reservation/pax/entities/travel-booking-types';

@Injectable()
export class AssistanceFacade {

  constructor(
    private store: Store<State>,
  ) { }

  public isLoadingAssistanceSearch$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.isLoadingAssistanceSearch)
    );

  public isErrorAssistanceSearch$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.isErrorAssistanceSearch)
    );

  public showAssistanceDetails$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.showAssistanceDetails)
    );

  public showAssistanceInfo$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.showAssistanceInfo)
    );

  public isLoadingAssistanceBook$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.isLoadingAssistanceBook)
    );

  public isErrorAssistanceBook$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.isErrorAssistanceBook)
    );

  public isLoadingAssistanceCancellation$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.isLoadingAssistanceCancellation)
    );

  public isLoadingConvertPdf$: Observable<boolean> = this.store
    .pipe(
      select(getUIAssistanceState),
      map((state: UiAssistanceState) => state.isLoadingConvertPdf)
    );

  public assistanceSearchInfo$: Observable<AssistanceSearchResponse> = this.store
    .pipe(select(assistanceRootSelector), map(state => state.assistanceSearchInfo));

  public assistancePdfUrl$: Observable<string> = this.store
    .pipe(select(assistanceRootSelector), map(state => state.assistanceConvertPdf));

  public setShowAssistanceDetails(payload: boolean): void {
    this.store.dispatch(actions.setShowAssistanceDetailsAction({ payload }));
  }

  public fetchAssistanceSearch(payload: AssistanceSearchPayload, bookingType: TravelBookingType): void {
    this.store.dispatch(actions.fetchAssistanceSearchAction({ payload, bookingType }));
  }

  public fetchAssistanceSearchByCrossSelling(payload: AssistanceSearchPayload): void {
    this.store.dispatch(actions.fetchAssistanceSearchByCrossSellingAction({ payload }));
  }

  public fetchAssistanceBookAction(payload: AssistanceBookPayload): void {
    this.store.dispatch(actions.fetchAssistanceBookAction({ payload }));
  }

  public resetAssistanceSearchInfo(): void {
    this.store.dispatch(actions.resetAssistanceSearchInfoAction());
  }

  public assistanceCancellation(payload: AssistanceCancellationPayload): void {
    this.store.dispatch(actions.fetchAssistanceCancellationAction({ payload }));
  }

  public convertAssistancePdf(payload: AssistanceConvertPdfPayload): void {
    this.store.dispatch(actions.fetchAssistanceConvertPdfAction({ payload }));
  }

  public cancelAssistanceConvertPdfAction(): void {
    this.store.dispatch(actions.cancelAssistanceConvertPdfAction());
  }

  public toggleShowAssistanceInfoAction(payload: boolean): void {
    this.store.dispatch(actions.toggleShowAssistanceInfoAction({ payload }));
  }

}
